import mustache from "mustache";
import { RunMode, RunModes } from "../../shared/BaseInit";
import { IAsideMenuRender } from "../../shared/components/definitions/app/IAsideMenuRender";
import { IPage } from "../../shared/components/definitions/page/IPage";
import { ConfirmModalRender } from "../../shared/components/implementations/modal/ConfirmModalRender";
import { RegistroFincaModalRender } from "../../shared/components/modulos/terceros/finca/modal/RegistroFincaModalRender";
import { serviceProvider } from "../../shared/comun/provider/ServiceProvider";
import { modalZIndexService } from "../../shared/comun/services/components/ModalZIndexService";
import { fx_createFincaClimaHorarioGrpcService } from "../../shared/modulos/clima/services/FincaClimaHorarioGrpcService";
import { ClienteFincaBaseResponse } from "../../shared/modulos/terceros/response/ClienteFincaBaseResponse";
import {
  grpcFincaLoteDatabase,
  toClienteFincaBaseResponse,
} from "../../shared/modulos/terceros/database/GrpcFincaLoteDatabase";
import {
  fx_pasoParaRetomar,
  RegistroFincaBorrador,
} from "../../shared/modulos/terceros/wizard/response/RegistroFincaBorrador";
import { parseWizardErrorMessage } from "../../shared/modulos/terceros/wizard/response/WizardValidationErrorResponse";
import { registroFincaTempGrpcService } from "../../shared/modulos/terceros/wizard/services/RegistroFincaTempGrpcService";
import { _miles } from "../../shared/utils/numberUtils";
import { LoginAuthResponse } from "../response/LoginAuthResponse";
import {
  APP_RUTA_APLICACIONES,
  APP_RUTA_CLIMA_CURRENT,
  APP_RUTA_CLIMA_FORECAST,
  APP_RUTA_FERTILIZACION,
  APP_RUTA_MONITOREO_ANALISIS,
  APP_RUTA_MONITOREO_BROCA,
  APP_RUTA_MONITOREO_PLAGAS,
  APP_RUTA_MONITOREO_REPORTE,
  APP_RUTA_PESAJE_GANADERIA_COMPRAS,
  APP_RUTA_PESAJE_GANADERIA_DASHBOARD,
  APP_RUTA_PESAJE_GANADERIA_ROTACION_PESAJE_VETERINARIA,
  APP_RUTA_PESAJE_GANADERIA_VENTAS,
  APP_RUTA_SATELITE,
  APP_RUTA_MIS_PROYECTOS,
  APP_RUTA_TAREAS,
  ClienteModulesComponent,
} from "./ClienteModulesComponent";
import fincasTemplate from "./fincasTemplate.html";
import modulesTemplate from "./modulesTemplate.html";
import navFincaAddTemplate from "./navFincaAddTemplate.html";
import navFincaReminderTemplate from "./navFincaReminderTemplate.html";
import statsTemplate from "./statsTemplate.html";
import template from "./template.html";
import { AplicacionesPage } from "../pages/AplicacionesPage";
import { ClimaCurrentPage } from "../pages/ClimaCurrentPage";
import { ClimaForecastPage } from "../pages/ClimaForecastPage";
import { ComprasPage } from "../pages/ComprasPage";
import { FertilizacionPage } from "../pages/FertilizacionPage";
import { FincaPage } from "../pages/FincaPage";
import { MonitoreoAnalisisPage } from "../pages/MonitoreoAnalisisPage";
import { MonitoreoBrocaPage } from "../pages/MonitoreoBrocaPage";
import { MonitoreoReportePage } from "../pages/MonitoreoReportePage";
import { MonitoreoSesionPage } from "../pages/MonitoreoSesionPage";
import { PesajeGanaderiaDashboardPage } from "../pages/PesajeGanaderiaDashboardPage";
import { RotacionPesajeVeterinariaPage } from "../pages/RotacionPesajeVeterinariaPage";
import { SatelitePage } from "../pages/SatelitePage";
import { MisProyectosPage } from "../pages/MisProyectosPage";
import { TareasPage } from "../pages/TareasPage";
import { VentasPage } from "../pages/VentasPage";

mustache.parse(fincasTemplate);
mustache.parse(statsTemplate);
mustache.parse(modulesTemplate);
mustache.parse(navFincaReminderTemplate);

export const APP_RUTA_FINCA = "/finca";

/** "Mis proyectos" oculto en producción (pedido del usuario, 2026-10-07): ni el ítem del menú ni la ruta,
 *  aunque se escriba a mano. Sigue visible en dev y test (`RunMode`). */
const MIS_PROYECTOS_VISIBLE = RunMode !== RunModes.Release;

export class ClienteAsideMenuRender implements IAsideMenuRender<LoginAuthResponse> {
  getPage(route: string): IPage | null {
    if (route == APP_RUTA_FINCA) {
      return new FincaPage();
    }

    switch (route) {
      case APP_RUTA_PESAJE_GANADERIA_DASHBOARD:
        return new PesajeGanaderiaDashboardPage();
      case APP_RUTA_APLICACIONES:
        return new AplicacionesPage();
      case APP_RUTA_FERTILIZACION:
        return new FertilizacionPage();
      case APP_RUTA_SATELITE:
        return new SatelitePage();
      case APP_RUTA_MONITOREO_BROCA:
        return new MonitoreoBrocaPage();
      case APP_RUTA_MONITOREO_ANALISIS:
        return new MonitoreoAnalisisPage();
      case APP_RUTA_MONITOREO_PLAGAS:
        return new MonitoreoSesionPage();
      case APP_RUTA_MONITOREO_REPORTE:
        return new MonitoreoReportePage();
      case APP_RUTA_PESAJE_GANADERIA_COMPRAS:
        return new ComprasPage();
      case APP_RUTA_PESAJE_GANADERIA_VENTAS:
        return new VentasPage();
      case APP_RUTA_PESAJE_GANADERIA_ROTACION_PESAJE_VETERINARIA:
        return new RotacionPesajeVeterinariaPage();
      case APP_RUTA_TAREAS:
        return new TareasPage();
      case APP_RUTA_MIS_PROYECTOS:
        return MIS_PROYECTOS_VISIBLE ? new MisProyectosPage() : null;
      case APP_RUTA_CLIMA_CURRENT:
        return new ClimaCurrentPage();
      case APP_RUTA_CLIMA_FORECAST:
        return new ClimaForecastPage();
    }

    return null;
  }

  /** Sincroniza el resaltado de los módulos con cada navegación (de menú o
   *  programática, p. ej. el botón volver de un segundo sidebar). */
  onNavigate(route: string): void {
    this._modulesComponent?.syncActive(route);
  }

  private _response!: LoginAuthResponse;

  render(response: LoginAuthResponse): string {
    this._response = response;
    return template;
  }

  connect(_response: LoginAuthResponse): void {
    this._navFincaReminder = document.getElementById(
      "navFincaReminder",
    ) as HTMLDivElement;
    if (!this._navFincaReminder) return;

    this._navFincaAdd = document.getElementById(
      "navFincaAdd",
    ) as HTMLDivElement;
    if (!this._navFincaAdd) return;

    this._navFincas = document.getElementById("navFincas") as HTMLDivElement;
    if (!this._navFincas) return;

    this._navFincaStats = document.getElementById(
      "navFincaStats",
    ) as HTMLDivElement;
    if (!this._navFincaStats) return;

    this._navModulos = document.getElementById("navModulos") as HTMLDivElement;
    if (!this._navModulos) return;

    // Las cifras de la finca (área total y productiva) siguen a la finca
    // seleccionada: se vuelven a pintar cada vez que se elige otra o que un
    // guardado la reemplaza. Por ejemplo, editar un lote recalcula sus
    // hectáreas productivas (2026-10-08); antes el menú quedaba con el valor
    // viejo hasta volver a hacer clic en la finca.
    serviceProvider.getFincaSelectedService().subscribe((finca) => {
      if (finca) this._renderStats(finca);
    });

    this._renderMisProyectos();

    Promise.all([
      this._getFincasAsync(),
      this._obtenerRegistroEnCursoAsync(),
    ]).then(([fincas, registroEnCurso]) => {
      this._registroEnCurso = registroEnCurso;
      this._clasificarFincasAsync(fincas).then(({ completas, incompleta }) => {
        // Se calcula la clasificación completa ANTES de renderizar: si hay
        // una finca incompleta, el modal de registro se abre más abajo y el
        // autoselect de la primera finca completa NO debe dispararse
        // (pisaría el wizard recién abierto con un `navigate()` a
        // `FincaPage`, y si esa finca autoseleccionada fuera ganadería sin
        // configurar, apilaría encima el modal obligatorio de configuración
        // — los dos modales a la vez, ver memoria del proyecto).
        this._renderFincas(completas, incompleta === null);
        this._renderReminder(incompleta);
        this._updateNavFincaAdd(
          fincas,
          incompleta !== null || registroEnCurso !== null,
        );

        // Un registro de finca en curso NO abre el wizard solo: queda el
        // recordatorio, que dice en qué paso va, para retomarlo cuando el
        // usuario quiera.
        // Finca sin AOI/lotes: fuerza el modal de registro al terminar el
        // login, ya apuntado a completar esa finca puntual (paso 2 directo,
        // ver RegistroFincaModalRender). Es cerrable (no bloquea la app) —
        // si se cierra, el recordatorio (#navFincaReminder) queda visible
        // para reabrirlo.
        if (incompleta) this._openRegistroModal(incompleta);
      });
    });
  }

  /** Fincas del cliente logueado, ya en el shape `ClienteFincaBaseResponse`
   *  que usa el resto de la app (ver `toClienteFincaBaseResponse`) — la base
   *  gRPC (`grpcFincaLoteDatabase`) ya las tiene desde el login/checkToken,
   *  actualizadas al toque por cada guardado puntual que hace `upsertFincaAsync`
   *  (wizard, configuración de ganadería/árboles), así que esto no pega al
   *  server salvo que la sesión recién haya arrancado. */
  private _getFincasAsync(): Promise<ClienteFincaBaseResponse[]> {
    return grpcFincaLoteDatabase
      .getFincasAsync()
      .then((fincas) => fincas.map(toClienteFincaBaseResponse));
  }

  /** Registro de finca en curso del cliente (wizard sin terminar, guardado
   *  en el esquema temporal del servidor), o `null`. Un error no traba el
   *  menú: se trata como si no hubiera. */
  private _obtenerRegistroEnCursoAsync(): Promise<RegistroFincaBorrador | null> {
    return registroFincaTempGrpcService
      .obtenerEnCursoAsync(this._response.clienteId)
      .then((leido) => leido?.borrador ?? null)
      .catch(() => null);
  }

  /** Relee el listado de fincas y el registro en curso, y re-renderiza lista
   *  + recordatorio + botón "+". */
  private _refreshFincaList = (): Promise<ClienteFincaBaseResponse[]> => {
    return Promise.all([
      this._getFincasAsync(),
      this._obtenerRegistroEnCursoAsync(),
    ]).then(([fincas, registroEnCurso]) => {
      this._registroEnCurso = registroEnCurso;
      return this._clasificarFincasAsync(fincas).then(
        ({ completas, incompleta }) => {
          this._renderFincas(completas, false);
          this._renderReminder(incompleta);
          this._updateNavFincaAdd(
            fincas,
            incompleta !== null || registroEnCurso !== null,
          );
          return fincas;
        },
      );
    });
  };

  /** Una finca cuenta como "completa" (mostrable/seleccionable) si tiene AOI
   *  definida **y** al menos un lote — sin ambos no hay nada real que
   *  mostrar: los mapas necesitan el AOI para el polígono general y los
   *  lotes para todo lo demás (fertilización, aplicaciones, pesaje, todos
   *  operan sobre lotes). **No se usa `pasoRegistroCompletado`** como
   *  criterio: ese campo solo lo actualiza el wizard de Cliente, así que una
   *  finca cargada por otra vía (el panel administrativo "Plataforma", que
   *  crea fincas con `POST /terceros/fincas/save` y les carga AOI/lotes por
   *  fuera del wizard) quedaría incorrectamente "incompleta" para siempre si
   *  se mirara ese campo — confirmado con datos reales de producción: fincas
   *  de Plataforma con AOI y lotes completos pero `pasoRegistroCompletado = 0`.
   *
   *  Los lotes salen de la caché (`grpcFincaLoteDatabase`), así que **todo
   *  guardado que cree lotes tiene que dejarlos ahí**: el wizard lo hace en
   *  `RegistroFincaTempGrpcService` (`replaceLotesDeFincaAsync`) al finalizar.
   *  Sin eso, una finca recién creada quedaba "incompleta" hasta el próximo
   *  login, aunque estuviera entera en la base. */
  private async _esCompletaAsync(
    finca: ClienteFincaBaseResponse,
  ): Promise<boolean> {
    if (finca.sateliteAreaGeografica === null) return false;
    const lotes = await grpcFincaLoteDatabase.getLotesByFincaIdAsync(finca.id);
    return lotes.length > 0;
  }

  /** Separa las fincas en completas (mostrables/seleccionables) e incompleta
   *  (la primera sin AOI/lotes, si hay alguna — varias incompletas es un
   *  caso borde, pero si pasa se completan de a una, igual que antes). Una
   *  sola pasada async para no repetir consultas de lotes entre el renderizado
   *  de la lista, el recordatorio y el botón "+ Nueva finca". */
  private _clasificarFincasAsync(
    fincas: ClienteFincaBaseResponse[],
  ): Promise<{
    completas: ClienteFincaBaseResponse[];
    incompleta: ClienteFincaBaseResponse | null;
  }> {
    return Promise.all(
      fincas.map(async (finca) => ({
        finca,
        completa: await this._esCompletaAsync(finca),
      })),
    ).then((resultados) => ({
      completas: resultados.filter((r) => r.completa).map((r) => r.finca),
      incompleta: resultados.find((r) => !r.completa)?.finca ?? null,
    }));
  }

  /** Abre el modal del wizard de registro. `fincaACompletar` distingue los 2
   *  modos: `null` da de alta una finca nueva (botón "+ Nueva finca"); una
   *  finca sin AOI/lotes completa esa finca puntual (recordatorio) — el
   *  wizard arranca en paso 2 con nombre/tipo ya conocidos y termina
   *  completando esa finca en vez de crear otra (ver
   *  `RegistroFincaModalRender`/`RegistroFincaPaso6Render`). */
  private _openRegistroModal(
    fincaACompletar: ClienteFincaBaseResponse | null = null,
  ): void {
    new RegistroFincaModalRender(
      this._response.clienteId,
      this._response.isDemoPlataforma ? null : this._response.maximoHectareas,
      (finca) => {
        this._refreshFincaList().then(() => this._clickFinca(finca.id));
      },
      fincaACompletar,
      // Al cerrar (sin terminar) el recordatorio pasa a mostrar el paso en
      // que quedó el registro.
      () => {
        this._refreshFincaList();
      },
    ).init();
  }

  /* DESACTIVADO (2026-10-09, pedido explícito): el único que llamaba a esto era
     el lápiz "Editar finca" de cada fila, que se quitó de la UI. Se comenta en
     vez de borrarse — el modo edición sigue entero del lado del servidor
     (`IniciarEdicionFinca`, que siembra el registro temporal con el área y los
     lotes de la finca y lo deja en el paso 4) y `RegistroFincaModalRender`
     sigue aceptando su parámetro. Volver a prenderlo es descomentar esto, el
     listener de `_renderFincas` y el `<span>` de `fincasTemplate.html`.

     Abría el wizard en modo edición sobre la finca del lápiz de esa fila
     (paso 4, dividir/unir lotes).

     La finca se releía del listado en vez de cerrarse sobre la del render: es
     el mismo criterio del click de la fila, así el upsert de un guardado
     reciente no quedaba afuera. NO seleccionaba ni navegaba: editar el predio
     B mientras se está mirando el A no debería mover al usuario de lugar.

     `onFincaCreated` iba vacío: una edición no crea ninguna finca. El cierre sí
     refrescaba la lista, igual que en el alta.

  private _openEdicionModal(fincaId: string): void {
    this._getFincasAsync().then((fincas) => {
      const finca = fincas.find((f) => f.id === fincaId);
      if (!finca) return;

      new RegistroFincaModalRender(
        this._response.clienteId,
        this._response.isDemoPlataforma ? null : this._response.maximoHectareas,
        () => {},
        null,
        () => {
          this._refreshFincaList();
        },
        finca,
      ).init();
    });
  }
  */

  /** Dispara el click sobre la finca recién creada (terminó el wizard) —
   *  reusa tal cual el handler ya wireado en `_renderFincas` (selecciona,
   *  navega, carga stats/módulos), sin duplicar esa lógica. Requiere que
   *  `_refreshFincaList()` ya haya terminado (la finca recién creada tiene
   *  `pasoRegistroCompletado = 6`, así que ya aparece en el listado
   *  filtrado). */
  private _clickFinca(fincaId: string): void {
    this._navFincas
      ?.querySelector<HTMLDivElement>(`[data-id="${fincaId}"]`)
      ?.click();
  }

  private _navFincaReminder: HTMLDivElement | null = null;
  private _registroEnCurso: RegistroFincaBorrador | null = null;
  private _navFincaAdd: HTMLDivElement | null = null;
  private _navFincas: HTMLDivElement | null = null;
  private _navFincaStats: HTMLDivElement | null = null;
  private _navModulos: HTMLDivElement | null = null;

  /** Muestra/oculta "+ Nueva finca" (no se pinta hasta tener el listado de
   *  fincas — mientras carga, `#navFincaAdd` queda vacío). Reglas, en orden
   *  de prioridad:
   *  1. Hay una finca sin AOI/lotes o un registro de finca en curso
   *     (`hayIncompleta`) → oculto siempre — se atiende eso primero
   *     (recordatorio/modal) en vez de arrancar otra: el servidor admite un
   *     solo registro en curso por cliente.
   *  2. Si no hay incompleta y el plan es demo (`isDemoPlataforma`) →
   *     visible siempre, sin mirar hectáreas.
   *  3. Si no hay incompleta y el plan NO es demo → visible solo si la suma
   *     de hectáreas de sus fincas es menor al máximo del plan
   *     (`maximoHectareas`); si no, oculto. */
  private _updateNavFincaAdd = (
    fincas: ClienteFincaBaseResponse[],
    hayIncompleta: boolean,
  ) => {
    if (!this._navFincaAdd) return;

    let mostrar: boolean;
    if (hayIncompleta) {
      mostrar = false;
    } else if (this._response.isDemoPlataforma) {
      mostrar = true;
    } else {
      const hectareasUsadas = fincas.reduce(
        (total, finca) => total + finca.hectareasFinca,
        0,
      );
      mostrar = hectareasUsadas < this._response.maximoHectareas;
    }

    if (!mostrar) {
      this._navFincaAdd.innerHTML = "";
      return;
    }

    this._navFincaAdd.innerHTML = navFincaAddTemplate;
    this._navFincaAdd
      .querySelector("#navFincaAddItem")
      ?.addEventListener("click", () => this._openRegistroModal());
  };

  /** Muestra/oculta el recordatorio persistente (`#navFincaReminder`),
   *  separado de la lista de fincas. Prioridad:
   *  1. Un registro de finca en curso (`_registroEnCurso`): dice en qué paso
   *     quedó y trae la opción de descartarlo. Click retoma el wizard (el
   *     modal siempre retoma el registro en curso).
   *  2. Una finca sin AOI/lotes (`incompleta`): click abre el wizard apuntado
   *     a completar esa finca puntual (paso 2 directo). */
  private _renderReminder = (incompleta: ClienteFincaBaseResponse | null) => {
    if (!this._navFincaReminder) return;

    const registro = this._registroEnCurso;
    if (!registro && !incompleta) {
      this._navFincaReminder.innerHTML = "";
      return;
    }

    const texto = registro
      ? `Terminar registro de ${registro.nombre ?? "finca"} · paso ${fx_pasoParaRetomar(registro)} de 6`
      : `Terminar registro de ${incompleta!.nombreFinca}`;

    this._navFincaReminder.innerHTML = mustache.render(
      navFincaReminderTemplate,
      { texto, descartable: registro !== null },
    );
    this._navFincaReminder
      .querySelector("#navFincaReminderItem")
      ?.addEventListener("click", () => this._openRegistroModal(incompleta));
    this._navFincaReminder
      .querySelector("#navFincaReminderDescartar")
      ?.addEventListener("click", (event) => {
        // Sin esto el click también llega al recordatorio y abre el wizard.
        event.stopPropagation();
        if (registro) this._confirmarDescarte(registro);
      });
  };

  /** Descarta el registro en curso, previa confirmación: se pierde todo lo
   *  que llevaba (nombre, área, lotes). */
  private _confirmarDescarte(registro: RegistroFincaBorrador): void {
    const registroId = registro.registroId;
    if (!registroId) return;

    new ConfirmModalRender({
      title: "Descartar registro",
      message: `¿Descartar el registro de ${registro.nombre ?? "la finca"}? Se pierde todo lo que llevas y no se puede recuperar.`,
      confirmLabel: "Descartar",
      onConfirm: async () => {
        try {
          await registroFincaTempGrpcService.descartarAsync(registroId);
        } catch (error) {
          serviceProvider
            .getErrorService()
            .addError(
              "Error al descartar el registro",
              parseWizardErrorMessage(error),
            );
        }
        await this._refreshFincaList();
      },
    }).init();
  }

  private _modulesComponent: ClienteModulesComponent | null = null;

  /** Renderiza la lista de fincas completas (ya filtradas por
   *  `_clasificarFincasAsync`) y engancha los clicks. `autoSelectFirst` solo
   *  aplica cuando no hay ninguna finca ya seleccionada (arranque de la
   *  app); si ya hay una, se le restaura el resaltado `.active` sin navegar
   *  ni disparar ningún click — un refresco de lista nunca debe abandonar lo
   *  que el usuario está haciendo. */
  /**
   * "Mis proyectos" va FUERA del menú de módulos de la finca, a propósito: los proyectos son
   * del agricultor, no de una finca, y el menú de módulos solo aparece tras entrar a una finca
   * completa. Si viviera ahí, un agricultor con proyectos pero sin finca terminada de registrar
   * —caso real en los datos de desarrollo— no podría llegar nunca a su propia vista.
   */
  private _renderMisProyectos(): void {
    const contenedor = document.getElementById("navMisProyectos");
    if (!contenedor || !MIS_PROYECTOS_VISIBLE) return;

    contenedor.innerHTML = `
      <div class="nav-item" data-page="${APP_RUTA_MIS_PROYECTOS}" style="margin-bottom: 2px;">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
          <path d="M3 3v18h18"></path>
          <path d="M7 15l4-4 3 3 5-6"></path>
        </svg>
        Mis proyectos
      </div>`;

    contenedor
      .querySelector<HTMLDivElement>(".nav-item")
      ?.addEventListener("click", () => {
        serviceProvider.getLayoutService().navigate(APP_RUTA_MIS_PROYECTOS);
      });
  }

  private _renderFincas = (
    fincasCompletas: ClienteFincaBaseResponse[],
    autoSelectFirst: boolean,
  ) => {
    if (!this._navFincas) return;

    this._navFincas.innerHTML = mustache.render(fincasTemplate, {
      fincas: fincasCompletas,
    });

    const fincaItems =
      this._navFincas.querySelectorAll<HTMLDivElement>(".nav-item");
    fincaItems.forEach((fincaItem) => {
      // Lápiz "Editar finca" DESACTIVADO (2026-10-09, pedido explícito). El
      // botón se comentó en `fincasTemplate.html`; esto queda comentado al
      // lado para que las dos mitades se prendan juntas.
      //
      // Abría el wizard sobre ESA finca, sin seleccionarla ni navegar.
      // `stopPropagation` porque el botón vive dentro de la fila y su click
      // también llegaría al handler de abajo.
      //
      // fincaItem
      //   .querySelector<HTMLElement>('[data-action="editar-finca"]')
      //   ?.addEventListener("click", (event) => {
      //     event.stopPropagation();
      //     const fincaId = fincaItem.dataset.id;
      //     if (fincaId) this._openEdicionModal(fincaId);
      //   });

      fincaItem.addEventListener("click", () => {
        fincaItems.forEach((fincaItem) => {
          fincaItem.classList.remove("active");
        });

        // Relee la lista en cada click (no la closure del boot): respeta los
        // upsert de los saves y entrega la finca fresca.
        this._getFincasAsync().then((fincasFrescas) => {
          const fincaSelected = fincasFrescas.find((finca) => {
            return finca.id == fincaItem.dataset.id;
          });
          if (!fincaSelected) return;

          fincaItem.classList.add("active");
          serviceProvider.getFincaSelectedService().set(fincaSelected);
          serviceProvider
            .getLayoutService()
            .setTitle(fincaSelected.nombreFinca);

          if (this._response.isDemoPlataforma == false) {
            fx_createFincaClimaHorarioGrpcService(fincaSelected.id)
              .getListAsync()
              .catch(() => {});
          }
          // Las cifras de la finca ya se pintaron al seleccionarla (ver la
          // suscripción en `connect`).
          this._renderModules(fincaSelected);
          serviceProvider.getLayoutService().navigate(APP_RUTA_FINCA);
        });
      });
    });

    const fincaActualId = serviceProvider.getFincaSelectedService().get()?.id;
    const fincaActualItem = Array.from(fincaItems).find(
      (item) => item.dataset.id === fincaActualId,
    );
    if (fincaActualItem) {
      fincaActualItem.classList.add("active");
    } else if (autoSelectFirst && modalZIndexService.getZIndex() <= 500) {
      // No autoseleccionar/navegar si ya hay un modal abierto (p. ej. el
      // usuario alcanzó a abrir "Registro de finca" mientras la app todavía
      // estaba resolviendo el boot): auto-navegar acá pisaría ese modal con
      // FincaPage y, si la finca autoseleccionada es ganadería sin
      // configurar, apilaría encima el modal obligatorio de configuración.
      fincaItems[0]?.click();
    }
  };

  private _renderStats = (finca: ClienteFincaBaseResponse) => {
    if (!this._navFincaStats) return;

    this._navFincaStats.innerHTML = mustache.render(statsTemplate, {
      areaHas: _miles(finca.hectareasFinca),
      areaProductiva: _miles(finca.hectareasProductivas),
    });
  };

  private _renderModules = (finca: ClienteFincaBaseResponse) => {
    this._modulesComponent?.dispose();

    if (!this._navModulos) return;

    this._modulesComponent = new ClienteModulesComponent(this._response, finca);
    this._navModulos.innerHTML = this._modulesComponent.render();
    this._modulesComponent.connect();
  };
}
